export default "__VITE_ASSET__c19PMuIk__"